import { http } from '@/lib/http';
import {
  type PostTermConsentParams,
  type PostTermConsentResponse,
  createHttpClient,
  postTermConsent as postTermConsentCommon,
} from '@monorepo/common';

export type { PostTermConsentParams, PostTermConsentResponse };

export const postTermConsent = async (params: PostTermConsentParams): Promise<PostTermConsentResponse> => {
  const httpClient = createHttpClient(http);
  return await postTermConsentCommon(params, httpClient);
};
